import {
  CaretDownFilled,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Form, Input, Space, Row, Select, Modal } from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { NavBar } from '../../../compnents/nav/NavBar'
import { ThemeContext } from '../../../theme/ThemeContext'
import { columns } from './PartnerColumns'
import { AddPartnerModel } from './AddPartnerModel'
import styles from './Partner.module.css'
import { useHistory, useLocation } from 'react-router-dom'
import { SupplierPartnerParams } from '../../../services/replaceMakeSupplier'
import {
  getSupplierPartnerList,
  isEditSupplierPartner,
} from '../ReplaceMakeSupplierSclice'

// 代煎饮片厂合作的代煎机构
export const SupplierPartner = (): ReactElement => {
  const theme = useContext(ThemeContext)

  const history = useHistory()

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const location: any = useLocation()

  const current = location.state?.current

  const [data, setData] = useState<any>()

  const [total, setTotal] = useState<any>()

  const [params, setParams] = useState<SupplierPartnerParams>({
    size: 10,
    current: location?.state?.current || 1,
    id: location?.state?.id,
  })

  const options = [
    {
      value: 10,
      label: '全部',
    },
    {
      value: 1,
      label: '已绑定',
    },
    {
      value: 2,
      label: '已解绑',
    },
  ]


  const [partnerId, setPartnerId] = useState('')

  const [isRelieveModel, setIsRelieveModel] = useState(false)

  const [bindId, setBindId] = useState('')

  const [listId, setListId] = useState('')

  const [isAddPartnerModel, setAddPartnerModelVisible] = useState(false)

  const [supplierName, setSupplierName] = useState('')


  useEffect(() => {
    dispatch(getSupplierPartnerList({ ...params }))
      .then(unwrapResult)
      .then((res: any) => {
        setData(res.records)
        setTotal(res.total)
      })
  }, [params])

  return (
    <>
      <Col className={styles.wrap}>
        <NavBar
          where={['代煎饮片厂', '合作机构']}
          backtrace={{
            name: '代煎饮片厂',
            path: '/admin/replaceMakeCenter/replaceMakeSupplier',
            routeName: '代煎饮片厂',
            // state: {
            //   current,
            //   queryParams: location.state?.queryParams,
            // },
          }}
          buttons={
            <Button
              type='primary'
              icon={<PlusOutlined />}
              onClick={() => setAddPartnerModelVisible(true)}
            >
              {'新增合作机构'}
            </Button>
          }
        />
        <Col className={styles.contentWrap}>
          <Form
            form={form}
            autoComplete='off'
            initialValues={{}}
            onFinish={(values) =>
              setParams({
                ...params,
                ...values,
              })
            }
          >
            <Row
              justify='space-between'
              align='middle'
              style={{ marginTop: 10, marginBottom: 20, width: '100%' }}
            >
              <Space>
                <Form.Item name='name' noStyle>
                  <Input
                    allowClear
                    placeholder='请输入机构名称/助记码'
                    prefix={<SearchOutlined />}
                    style={{ width: '315px' }}
                    onChange={form.submit}
                  />
                </Form.Item>
                <Form.Item name='status' noStyle>
                  <Select
                    suffixIcon={
                      <CaretDownFilled style={{ color: theme.tc3 }} />
                    }
                    placeholder='代煎类别'
                    onChange={form.submit}
                    style={{ width: '200px' }}
                  >
                    {options.map((c) => (
                      <Select.Option key={c.value} value={c.value}>
                        绑定状态-{c.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name='signedType' noStyle>
                  <Select
                    suffixIcon={
                      <CaretDownFilled style={{ color: theme.tc3 }} />
                    }
                    placeholder='签约状态'
                    onChange={form.submit}
                    style={{ width: '200px' }}
                  >
                    <Select.Option value={''}>全部</Select.Option>
                    <Select.Option value={1}>已签约</Select.Option>
                    <Select.Option value={0}>未签约</Select.Option>
                  </Select>
                </Form.Item>
              </Space>
              <Button type='primary' onClick={form.submit}>
                查询
              </Button>
            </Row>
          </Form>
          <EditableList
            page={{
              items: data,
              current: params.current || 1,
              size: params.size || 10,
              total,
            }}
            style={{ color: theme.tc3 }}
            className={styles.table}
            columns={columns(
              (action, t: any) => {
                switch (action) {
                  case 'relieve':
                    setBindId(t.id)
                    setSupplierName(t.tenantName)
                    setIsRelieveModel(true)
                    break
                  case 'setting':
                    setListId(t.id)
                    setPartnerId(t.tenantId)
                    setAddPartnerModelVisible(true)
                    break
                  case 'againBind':
                    setListId(t.id)
                    setPartnerId(t.tenantId)
                    setAddPartnerModelVisible(true)
                    break
                  case 'herbs':
                    history.push({
                      pathname: '/admin/replaceMakeCenter/HerbsDirectory',
                      state: {
                        status: 2,
                        supplierId: location?.state?.id,   //饮片厂 id
                        tenantId: t.tenantId,   //机构 Id
                        supplierName: location?.state?.supplierName,
                      },
                    })
                    break
                }
              },
              (params.size || 10) * ((params.current || 1) - 1),
              theme
            )}
            onChangePage={(current: number, size?: number) =>
              setParams({
                ...params,
                current: current,
                size: size || 10,
              })
            }
            onRow={(t: any) => ({
              onDoubleClick: () => {
                setListId(t.id)
                setPartnerId(t.tenantId)
                setAddPartnerModelVisible(true)
              },
            })}
          />
        </Col>
        <AddPartnerModel
          partnerId={partnerId}
          supplierId={location.state.id}
          listId={listId}
          supplierName={location.state.supplierName}
          visible={isAddPartnerModel}
          onCancel={() => {
            setPartnerId('')
            setAddPartnerModelVisible(false)
          }}
          onOk={() => {
            setPartnerId('')
            setAddPartnerModelVisible(false)
            dispatch(getSupplierPartnerList({ ...params }))
              .then(unwrapResult)
              .then((res: any) => {
                setData(res.records)
                setTotal(res.total)
              })
          }}
        />
        {/* 解除绑定弹框 */}
        <Modal
          visible={isRelieveModel}
          title={'解除绑定'}
          width={700}
          cancelText='取消'
          okText='确定'
          onCancel={() => {
            setIsRelieveModel(false)
          }}
          onOk={() => {
            dispatch(isEditSupplierPartner({ id: bindId, status: 2 }))
              .then(unwrapResult)
              .then(() => {
                dispatch(getSupplierPartnerList({ ...params }))
                  .then(unwrapResult)
                  .then((res: any) => {
                    setData(res.records)
                    setTotal(res.total)
                  })
                setIsRelieveModel(false)
              })
          }}
        >
          确认解除 {location.state?.supplierName} 与 {supplierName} 的绑定关系？
        </Modal>
      </Col>
    </>
  )
}
